import intl from "react-intl-universal";

import {SectionMessage} from "../../components/SectionMessage";
import {Button} from "../../components/Button";
import {RefreshIcon} from "../../components/icons/RefreshIcon";


import './UnexpectedErrorMessage.css';


export const UnexpectedErrorMessage = () => {
    const contact_us = `<button onclick="window.open('/pricing#Contact_us', '_blank').focus();"
 class="btn btn--inline btn--primary btn--clickable title-medium">${intl.get('unexpected_error.contact_us').d('contact our support team')}</button>`;

    return (
        <div className="UnexpectedErrorMessage">
            <SectionMessage
                className={'UnexpectedErrorMessage_block'}
                variant={'warning'}
                title={intl.get('unexpected_error.title').d('An unexpected error occurred')}
                maxWidth={'640px'}
                message={(
                    <>
                        <div>{intl.get('unexpected_error.message').d(`We've been notified of the issue and are working to resolve it.`)}</div>
                        <ul className="UnexpectedErrorMessage_options">
                            <li>{intl.getHTML('unexpected_error.option1').d(`<b>Please refresh the page</b> to continue using the website.`)}</li>
                            <li>{intl.getHTML('unexpected_error.option2', {contact_us}).d(`If the problem persists, feel free to {contact_us} for assistance`)}</li>
                        </ul>
                        <Button
                            type={'primary'}
                            Icon={RefreshIcon}
                            size={'sm'}
                            style={'solid'}
                            text={intl.get('unexpected_error.button').d('Refresh page')}
                            onClick={() => location.reload()}
                        />
                    </>
                )}
            />
        </div>
    )
}
